import { createContext, useContext } from 'react';
import { Ability } from '@casl/ability';
import { createContextualCan } from '@casl/react';

export const AbilityContext = createContext();
export const useAbilityContext = () => useContext(AbilityContext);
export const Can = createContextualCan(AbilityContext.Consumer);

export const ability = new Ability([]);
